<section class="app-dialog cc-dialogo-qa">
  <header class="app-dialog__header">
    <div class="app-dialog__heading">
      <span class="cc-dialogo-qa__icono" aria-hidden="true">
        <span class="material-icons">summarize</span>
      </span>
      <div>
        <p class="app-dialog__eyebrow">Calidad de código</p>
        <h2 [id]="idTitulo">Nuevo reporte para QA</h2>
        <p>Qué falla, desde cuándo y cuántos análisis lleva así; al emitir se trae lo último de SonarQube de cada proyecto.</p>
      </div>
    </div>
    <button type="button" class="app-dialog__close cc-dialogo-qa__cerrar" aria-label="Cerrar" [disabled]="enviando"
            (click)="cancelar()">
      <span class="material-icons" aria-hidden="true">close</span>
    </button>
  </header>

  <div mat-dialog-content class="app-dialog__content cc-dialogo-qa__contenido">
    <fieldset class="cc-dialogo-qa__grupo">
      <legend id="cc-reporte-qa-proyectos">Proyectos</legend>
      <output class="cc-dialogo-qa__cargando" *ngIf="cargando">
        <span class="material-icons" aria-hidden="true">hourglass_top</span>
        Leyendo la lista de proyectos…
      </output>
      <mat-radio-group class="cc-dialogo-qa__opciones" [(ngModel)]="alcance" [disabled]="enviando || cargando"
                       (ngModelChange)="mensaje = ''" aria-labelledby="cc-reporte-qa-proyectos">
        <mat-radio-button value="LISTA"><span class="cc-dialogo-qa__texto">{{ textoLista }}</span></mat-radio-button>
        <mat-radio-button value="NO_PASAN"><span class="cc-dialogo-qa__texto">Solo los {{ noPasan }} que no pasan</span></mat-radio-button>
        <mat-radio-button value="ELEGIDOS"><span class="cc-dialogo-qa__texto">Elegir proyectos</span></mat-radio-button>
      </mat-radio-group>

      <ul class="cc-dialogo-qa__lista" *ngIf="alcance === 'ELEGIDOS'">
        <li *ngFor="let p of proyectos; trackBy: trackProyecto">
          <mat-checkbox [checked]="elegido(p.id)" [disabled]="enviando" (change)="alterna(p.id, $event.checked)">
            <span class="cc-dialogo-qa__texto">{{ p.nombre }}</span>
          </mat-checkbox>
          <span class="cc-insignia" [ngClass]="p.estado.clase">
            <span class="material-icons" aria-hidden="true">{{ p.estado.icono }}</span>
            {{ p.estado.texto }}
          </span>
        </li>
      </ul>
    </fieldset>

    <fieldset class="cc-dialogo-qa__grupo">
      <legend>Contenido</legend>
      <div class="cc-dialogo-qa__opciones">
        <mat-checkbox [(ngModel)]="contenido.criterios" [disabled]="enviando">
          <span class="cc-dialogo-qa__texto">Criterios que fallan, desde cuándo y cuántos análisis seguidos</span>
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="contenido.aceptados" [disabled]="enviando">
          <span class="cc-dialogo-qa__texto">Hallazgos aceptados (nuevos y en total)</span>
        </mat-checkbox>
        <mat-checkbox [(ngModel)]="contenido.trazabilidad" [disabled]="enviando">
          <span class="cc-dialogo-qa__texto">Trazabilidad del análisis (commit y su enlace)</span>
        </mat-checkbox>
      </div>
    </fieldset>

    <p class="cc-dialogo-qa__mensaje" role="alert">{{ mensaje }}</p>
  </div>

  <footer mat-dialog-actions class="app-dialog__footer cc-dialogo-qa__pie">
    <span class="cc-dialogo-qa__folio cc-sec">El folio QA-AAAAMMDD-NNNN se asigna al emitir y queda en Reportes.</span>
    <button type="button" class="app-form-btn app-form-btn--secondary app-form-btn--compact" [disabled]="enviando"
            (click)="cancelar()">
      Cancelar
    </button>
    <button type="button" class="app-form-btn app-form-btn--primary app-form-btn--compact" [disabled]="!listo"
            [attr.aria-busy]="enviando" [attr.title]="enviando ? emitiendoPdf : null" (click)="emitir()">
      {{ enviando ? "Emitiendo…" : "Emitir y descargar PDF" }}
    </button>
  </footer>
</section>
